/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { ButtonGroup, Card } from "react-bootstrap";
import { Button, Table } from "../../../components";
import { GetAllRentingStockList } from "../../../utilities/api/stock/rent";
import { toast } from "react-toastify";

const ServicesStockList = () => {
  const navigate = useNavigate();

  const { SelectedFacility } = useAppSelector((state) => state.facilityList);

  const [data, setData] = useState([]);

  const RentListHeader = ["Sr No", "Product Name", "Last Inward Date", "Last Inward Quantity", "In Service Quantity", "Available Quantity", "Service Charges (per 30 Min)", "Service Amount", "Total Product Value", "Status"]
  const RentListAccessor = ["srNo", "name", "updatedAt", "totalQuantity", "onRentQuantity", "availableQuantity", "rentingPrice", "todayRentTotalAmount", "productValue", "isActive"]
  const columns = React.useMemo(
    () => RentListHeader.map((item, index) => (
      {
        Header: item,
        accessor: RentListAccessor[index],
      }
    )), []);

  const GetData = async () => {
    const result = await GetAllRentingStockList(SelectedFacility);
    if (result?.statusCode === 200) {
      setData(
        result.data.rows.map((item: any, index: number) => {
          return {
            ...(item || {}),
            srNo: index + 1,
            name: item?.name,
            updatedAt: item?.updatedAt,
            productValue: item?.costPrice * item?.totalQuantity,
            isActive: item?.isActive === true ? "Active" : "Inactive",
          };
        })
      );
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetData();
  }, [SelectedFacility]);



  const handleAdd = () => {
    navigate("/add-rent-stock");
  };

  const handleEdit = (id: string) => {
    navigate(`/update-rent-stock/${id}`, { state: id });
  };

  const handleUserInfo = (id: string) => {
    navigate(`/rent-stock-info/${id}`, { state: id });
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Services Stock List</Card.Title>
            <ButtonGroup>
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Inventory"
                name="add-inventory"
                id="add-inventory"
                className="btn btn-primary rounded-1"
              ></Button>
            </ButtonGroup>
          </div>
        </Card.Body>
        <Table
          columns={columns}
          data={data}
          handleEdit={handleEdit}
          HandleShow={handleUserInfo}
          hideDeleteAction={true}
        />
      </Card>
    </>
  );
};

export { ServicesStockList };
